import React from 'react'
import { SkeletonText } from '@offerzen/pinata-shame'
import styles from './styles'

const SkeletonWorkAuthorisationsList = ({ theme }) => (
  <div className={styles.card}>
    <div className={styles.listItem}>
      <SkeletonText theme={theme} className={styles.listName}>
        145x18
      </SkeletonText>
      <SkeletonText theme={theme} className={styles.listActions}>
        54x18
      </SkeletonText>
    </div>
    <SkeletonText theme={theme} className={styles.listMeta}>
      200x18
    </SkeletonText>
  </div>
)

export default SkeletonWorkAuthorisationsList
